export default "__VITE_ASSET__BljenftV__"